"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationStatus = void 0;
var ProductImplementationStatus;
(function (ProductImplementationStatus) {
    ProductImplementationStatus["NEW"] = "new";
    ProductImplementationStatus["ASSIGNED"] = "assigned";
    ProductImplementationStatus["IN_PROCESS"] = "in-process";
    ProductImplementationStatus["DONE"] = "done";
})(ProductImplementationStatus = exports.ProductImplementationStatus || (exports.ProductImplementationStatus = {}));
//# sourceMappingURL=product-implementation-status.enum.js.map